import { RouteConfigComponentProps, renderRoutes } from 'react-router-config';

const Analysis = ({ route }: RouteConfigComponentProps) => {
  return <div>{renderRoutes(route?.routes)}</div>;
};

export default Analysis;
